export const SHARED_ROUTE_IDS = {
  DASHBOARD: 'dashboard',
  ERROR: 'error',
  PROFILE: 'profile',
  // Mein Profil tabs, the same in both apps
  PROFILE_PERSONAL: 'profile-personal',
  PROFILE_PASSWORD: 'profile-password',
  PROFILE_NOTIFICATIONS: 'profile-notifications',
  // Admin-App Sidebar-Navigation
  ADMIN_REGULATIONS: 'admin-regulations',
  ADMIN_REGULATIONS_INTERNATIONAL: 'admin-regulations-international',
  ADMIN_REGULATIONS_SUVA_CHECKLISTS: 'admin-regulations-suva-checklists',
  ADMIN_COMMENTS: 'admin-comments',
  ADMIN_CONSULTATIONS: 'admin-consultations',
  ADMIN_OBJECTS: 'admin-objects',
  ADMIN_CUSTOMERS: 'admin-customers',
  // Admin-App Kunden tabs
  ADMIN_CUSTOMERS_EXISTING: 'admin-customers-existing',
  ADMIN_CUSTOMERS_ACQUISITION: 'admin-customers-acquisition',
  ADMIN_CUSTOMERS_NEWSLETTER: 'admin-customers-newsletter',
  ADMIN_CUSTOMERS_ALL: 'admin-customers-all',
  // Admin-App Kunde detail page and its tabs
  ADMIN_CUSTOMER_DETAIL_OVERVIEW: 'admin-customer-detail-overview',
  ADMIN_CUSTOMER_DETAIL_SITES: 'admin-customer-detail-sites',
  ADMIN_CUSTOMER_DETAIL_CONTACTS: 'admin-customer-detail-contacts',
  ADMIN_CUSTOMER_DETAIL_ORDERS: 'admin-customer-detail-orders',
  ADMIN_CUSTOMER_DETAIL_DOCUMENTS: 'admin-customer-detail-documents',
  ADMIN_CUSTOMER_DETAIL_NOTES: 'admin-customer-detail-notes',
  // Admin-App Standort detail page (within a Kunde) and its tabs
  ADMIN_SITE_DETAIL_OVERVIEW: 'admin-site-detail-overview',
  ADMIN_SITE_DETAIL_PUBLISHERS: 'admin-site-detail-publishers',
  ADMIN_SITE_DETAIL_TOPICS: 'admin-site-detail-topics',
  ADMIN_SITE_DETAIL_UPDATES: 'admin-site-detail-updates',
  ADMIN_SITE_DETAIL_DOCUMENTS: 'admin-site-detail-documents',
  ADMIN_REPORTS: 'admin-reports',
  ADMIN_MASTER_DATA: 'admin-master-data',
  // Admin-App Stammdaten sub-pages
  ADMIN_MASTER_DATA_REGULATION_TYPES: 'admin-master-data-regulation-types',
  ADMIN_MASTER_DATA_PUBLISHERS: 'admin-master-data-publishers',
  ADMIN_MASTER_DATA_INTERNATIONAL_PUBLISHERS: 'admin-master-data-international-publishers',
  ADMIN_MASTER_DATA_LEGAL_AREAS: 'admin-master-data-legal-areas',
  ADMIN_MASTER_DATA_TOPIC_AREA_CATEGORIES: 'admin-master-data-topic-area-categories',
  ADMIN_ADMINISTRATION: 'admin-administration',
  // Admin-App Administration tabs
  ADMIN_ADMINISTRATION_USERS: 'admin-administration-users',
  ADMIN_ADMINISTRATION_USERS_NEW: 'admin-administration-users-new',
  ADMIN_ADMINISTRATION_NEWSLETTER: 'admin-administration-newsletter',
  ADMIN_ADMINISTRATION_NEWS: 'admin-administration-news',
  ADMIN_ADMINISTRATION_NEWS_NEW: 'admin-administration-news-new',
  ADMIN_ADMINISTRATION_EMAIL_TEMPLATES: 'admin-administration-email-templates',
  ADMIN_ADMINISTRATION_FAQ: 'admin-administration-faq',
  ADMIN_ADMINISTRATION_FAQ_NEW: 'admin-administration-faq-new',
  ADMIN_ADMINISTRATION_PRIVACY_POLICY: 'admin-administration-privacy-policy',
  ADMIN_ADMINISTRATION_PRIVACY_POLICY_NEW: 'admin-administration-privacy-policy-new',
  ADMIN_ADMINISTRATION_ROLES: 'admin-administration-roles',
  ADMIN_ADMINISTRATION_CORTEC: 'admin-administration-cortec',
  ADMIN_ADMINISTRATION_EMAIL_LOG: 'admin-administration-email-log',
} as const;

export const LOCALIZED_SHARED_ROUTES: Record<string, Record<string, string>> = {
  [SHARED_ROUTE_IDS.DASHBOARD]: {
    de: 'dashboard',
    fr: 'dashboard',
    it: 'dashboard',
    en: 'dashboard',
  },
  [SHARED_ROUTE_IDS.ERROR]: {
    de: 'fehler',
    fr: 'erreur',
    it: 'errore',
    en: 'error',
  },
  [SHARED_ROUTE_IDS.PROFILE]: {
    de: 'mein-profil',
    fr: 'mon-profil',
    it: 'mio-profilo',
    en: 'my-profile',
  },
  [SHARED_ROUTE_IDS.PROFILE_PERSONAL]: {
    de: 'persoenliche-angaben',
    fr: 'informations-personnelles',
    it: 'dati-personali',
    en: 'personal-details',
  },
  [SHARED_ROUTE_IDS.PROFILE_PASSWORD]: {
    de: 'passwort',
    fr: 'mot-de-passe',
    it: 'password',
    en: 'password',
  },
  [SHARED_ROUTE_IDS.PROFILE_NOTIFICATIONS]: {
    de: 'benachrichtigungen',
    fr: 'notifications',
    it: 'notifiche',
    en: 'notifications',
  },
  [SHARED_ROUTE_IDS.ADMIN_REGULATIONS]: {
    de: 'erlasse',
    fr: 'actes',
    it: 'atti',
    en: 'regulations',
  },
  [SHARED_ROUTE_IDS.ADMIN_REGULATIONS_INTERNATIONAL]: {
    de: 'internationale-erlasse',
    fr: 'actes-internationaux',
    it: 'atti-internazionali',
    en: 'international-regulations',
  },
  [SHARED_ROUTE_IDS.ADMIN_REGULATIONS_SUVA_CHECKLISTS]: {
    de: 'suva-checklisten',
    fr: 'listes-controle-suva',
    it: 'liste-controllo-suva',
    en: 'suva-checklists',
  },
  [SHARED_ROUTE_IDS.ADMIN_COMMENTS]: {
    de: 'kommentare',
    fr: 'commentaires',
    it: 'commenti',
    en: 'comments',
  },
  [SHARED_ROUTE_IDS.ADMIN_CONSULTATIONS]: {
    de: 'vernehmlassungen',
    fr: 'consultations',
    it: 'consultazioni',
    en: 'consultations',
  },
  [SHARED_ROUTE_IDS.ADMIN_OBJECTS]: {
    de: 'objekte',
    fr: 'objets',
    it: 'oggetti',
    en: 'objects',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMERS]: {
    de: 'kunden',
    fr: 'clients',
    it: 'clienti',
    en: 'customers',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMERS_EXISTING]: {
    de: 'bestandskunden',
    fr: 'clients-existants',
    it: 'clienti-esistenti',
    en: 'existing-customers',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMERS_ACQUISITION]: {
    de: 'akquisition',
    fr: 'acquisition',
    it: 'acquisizione',
    en: 'acquisition',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMERS_NEWSLETTER]: {
    de: 'newsletter',
    fr: 'newsletter',
    it: 'newsletter',
    en: 'newsletter',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMERS_ALL]: {
    de: 'alle',
    fr: 'tous',
    it: 'tutti',
    en: 'all',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMER_DETAIL_OVERVIEW]: {
    de: 'uebersicht',
    fr: 'apercu',
    it: 'panoramica',
    en: 'overview',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMER_DETAIL_SITES]: {
    de: 'standorte',
    fr: 'sites',
    it: 'sedi',
    en: 'sites',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMER_DETAIL_CONTACTS]: {
    de: 'kontakte',
    fr: 'contacts',
    it: 'contatti',
    en: 'contacts',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMER_DETAIL_ORDERS]: {
    de: 'auftraege',
    fr: 'commandes',
    it: 'ordini',
    en: 'orders',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMER_DETAIL_DOCUMENTS]: {
    de: 'dokumente',
    fr: 'documents',
    it: 'documenti',
    en: 'documents',
  },
  [SHARED_ROUTE_IDS.ADMIN_CUSTOMER_DETAIL_NOTES]: {
    de: 'notizen',
    fr: 'notes',
    it: 'note',
    en: 'notes',
  },
  [SHARED_ROUTE_IDS.ADMIN_SITE_DETAIL_OVERVIEW]: {
    de: 'uebersicht',
    fr: 'apercu',
    it: 'panoramica',
    en: 'overview',
  },
  [SHARED_ROUTE_IDS.ADMIN_SITE_DETAIL_PUBLISHERS]: {
    de: 'herausgeber',
    fr: 'editeurs',
    it: 'editori',
    en: 'publishers',
  },
  [SHARED_ROUTE_IDS.ADMIN_SITE_DETAIL_TOPICS]: {
    de: 'themenbereiche',
    fr: 'domaines-thematiques',
    it: 'temi',
    en: 'topics-areas',
  },
  [SHARED_ROUTE_IDS.ADMIN_SITE_DETAIL_UPDATES]: {
    de: 'aktualisierungen',
    fr: 'mises-a-jour',
    it: 'aggiornamenti',
    en: 'updates',
  },
  [SHARED_ROUTE_IDS.ADMIN_SITE_DETAIL_DOCUMENTS]: {
    de: 'dokumente',
    fr: 'documents',
    it: 'documenti',
    en: 'documents',
  },
  [SHARED_ROUTE_IDS.ADMIN_REPORTS]: {
    de: 'auswertungen',
    fr: 'analyses',
    it: 'valutazioni',
    en: 'reports',
  },
  [SHARED_ROUTE_IDS.ADMIN_MASTER_DATA]: {
    de: 'stammdaten',
    fr: 'donnees-de-base',
    it: 'dati-base',
    en: 'master-data',
  },
  [SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_REGULATION_TYPES]: {
    de: 'erlasstypen',
    fr: 'types-d-actes',
    it: 'tipi-di-atti',
    en: 'regulation-types',
  },
  [SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_PUBLISHERS]: {
    de: 'herausgeber',
    fr: 'editeurs',
    it: 'editori',
    en: 'publishers',
  },
  [SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_INTERNATIONAL_PUBLISHERS]: {
    de: 'internationale-herausgeber',
    fr: 'editeurs-internationaux',
    it: 'editori-internazionali',
    en: 'international-publishers',
  },
  [SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_LEGAL_AREAS]: {
    de: 'rechtsbereiche',
    fr: 'domaines-juridiques',
    it: 'ambiti-giuridici',
    en: 'legal-areas',
  },
  [SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_TOPIC_AREA_CATEGORIES]: {
    de: 'themenbereich-kategorien',
    fr: 'categories-de-domaines-thematiques',
    it: 'categorie-di-aree-tematiche',
    en: 'topic-area-categories',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION]: {
    de: 'administration',
    fr: 'administration',
    it: 'amministrazione',
    en: 'administration',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_USERS]: {
    de: 'benutzer',
    fr: 'utilisateurs',
    it: 'utenti',
    en: 'users',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_USERS_NEW]: {
    de: 'neu',
    fr: 'nouveau',
    it: 'nuovo',
    en: 'new',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_NEWSLETTER]: {
    de: 'newsletter',
    fr: 'newsletter',
    it: 'newsletter',
    en: 'newsletter',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_NEWS]: {
    de: 'news',
    fr: 'actualites',
    it: 'novita',
    en: 'news',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_NEWS_NEW]: {
    de: 'neu',
    fr: 'nouveau',
    it: 'nuovo',
    en: 'new',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_EMAIL_TEMPLATES]: {
    de: 'e-mail-vorlagen',
    fr: 'modeles-e-mail',
    it: 'modelli-e-mail',
    en: 'email-templates',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_FAQ]: {
    de: 'faq',
    fr: 'faq',
    it: 'faq',
    en: 'faq',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_FAQ_NEW]: {
    de: 'neu',
    fr: 'nouveau',
    it: 'nuovo',
    en: 'new',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_PRIVACY_POLICY]: {
    de: 'datenschutzbestimmungen',
    fr: 'protection-des-donnees',
    it: 'protezione-dei-dati',
    en: 'privacy-policy',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_PRIVACY_POLICY_NEW]: {
    de: 'neu',
    fr: 'nouveau',
    it: 'nuovo',
    en: 'new',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_ROLES]: {
    de: 'rollen',
    fr: 'roles',
    it: 'ruoli',
    en: 'roles',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_CORTEC]: {
    de: 'cortec',
    fr: 'cortec',
    it: 'cortec',
    en: 'cortec',
  },
  [SHARED_ROUTE_IDS.ADMIN_ADMINISTRATION_EMAIL_LOG]: {
    de: 'e-mail-protokoll',
    fr: 'journal-e-mail',
    it: 'registro-e-mail',
    en: 'email-log',
  },
};
